import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class ConstantConfigService {
  routeArr:any[][];
  constructor() {

  }

  
  
  //Local Configuration
  // public static get baseURL(): string { return "https://"+this.domain+"api"; }
  // public static get ImageUrl(): string { return "https://"+this.domain; }
  // public static get appURL(): string { return "https://"+this.domainAng; }
  // public static get AngularUrl(): string { return "http://localhost:4401/"; }
  // public static get versionJonPath(): string { return "https://"+this.domainAng+"version.json"; }
   public static get domainAng(): any { return "napp.trackmydocs.co/"; }
   public static get domain(): any { return "new.trackmydocs.co/"; }
   public static get baseURL(): string { return "https://"+this.domain+"api"; }
   public static get ImageUrl(): string { return "https://"+this.domain; }
   public static get appURL(): string { return "https://"+this.domainAng; } 
   public static get AngularUrl(): string { return "https://"+this.domainAng; }
   //public static get AngularUrl(): string { return "http://localhost:4200/"; }
   //public static get cookieDomain(): string { return "localhost"; }
   public static get cookieDomain(): string { return "napp.trackmydocs.co"; }
   public static get versionJonPath(): string { return "https://"+this.domainAng+"version.json"; }
   public static get CookieExpireTokenTime(): number { return 1; }
   public static get AuthModeCookieExpireTime2Week(): number { return 14; }
   public static get AuthModeCookieExpireTime4Week(): number { return 28; }
   public static get AuthModeCookieExpireTimeAlways(): number { return 0; }
   public static get AuthModeCookieEncryptionKey(): string { return "wfVJMILwRXFAvzhzurFBc8uw"; }
   public static get accessToken(): string { return "access_token"; }
   public static get apiToken(): string { return "api_token"; }
   public static get apiTokenCRM(): string { return "api_token_crm"; }
   public static get securityToken(): string { return "security_token"; }
   public static get securityTokenCRM(): string { return "sTknCRM"; }
   public static get captchaKey(): string { return "6Ldq4hgUAAAAAG29-ZKwU-vKE5QY-ed20H1wobOK"; }
   public static get stripeTestPublishKey(): string { return "pk_test_VJLwfwRFAvzhzurFMwIBcX8u"; }
   public static get stripeFoodeazeTestPublishKey(): string { return "pk_test_VJLwfwRFAvzhzurFMwIBcX8u"; }
   public static get guestToken(): string { return "guest_token"; }
	 public static get slackURL(): string { return "https://slack.com/oauth/v2/authorize?"; }
   public static get CryptoKey(): string { return "ijEWo+IOmBUjnGVY/W0RYgFc0t3Yj/rVbqBjSTjNV6k="; }
   public static get getAutoLoginCredentials(){
      let cred = {
          comp_id: 601,
          comtype:"scom",
          email: "21arvindverma@gmail.com",
          is_individual: 0,
          password: "Asdd@12345",
          role_id: 4,
          step: 1
      };
      return cred;
   }

}
